import React from 'react'
import AutoPopulatedTimesheet from '../AutoPopulatedTimesheet/AutoPopulatedTimesheet'
import SimpleAlert from '../../DanitComponents/Modals/SimpleAlert'

const CalendarGeneratedTimesheetFlow = ({month, myYear, rate, userData, setOpenUpTheTimesheet, setThankYouForSubmitting, setTryingToSubmitTimesheet, pushNewTimesheetToTimesheets, setBottomMenuView}) => {
    const [step, setStep] = React.useState(1)

    const noFunc1 = () => {
        setOpenUpTheTimesheet(false)
        setStep(1)
    }

    const noFunc2 = () => {
        setStep(1)
        setBottomMenuView('calendar')
        setOpenUpTheTimesheet(false)
    }

    return (
        <div>
            {step === 1 && <SimpleAlert 
                    title={'Are you done for the month?'} 
                    message={'Please wait until you have taught all your lessons for the month before submitting your timesheet.'} 
                    yesFunction={() => setStep(2)} 
                    noFunction={noFunc1}
                    yesText={'Yes, I\'m done'} 
                    noText={'No, not done'} 
                />
            }
            {step === 2 && <SimpleAlert
                    title={'Is your calendar correct?'} 
                    message={'It is very important that your calendar is 100% accurate. Please remember this is directly related to billing.'} 
                    yesFunction={() => setStep(3)} 
                    noFunction={noFunc2}
                    yesText={'Yes, it\'s correct'} 
                    noText={'Go to calendar'} 
            />}
             {step === 3 && <AutoPopulatedTimesheet month={month} myYear={myYear} reviewing={false} rate={rate} userData={userData} setOpenUpTheTimesheet={setOpenUpTheTimesheet} setThankYouForSubmitting={setThankYouForSubmitting} setTryingToSubmitTimesheet={setTryingToSubmitTimesheet} pushNewTimesheetToTimesheets={pushNewTimesheetToTimesheets}  />}
        </div>
    )
}
export default CalendarGeneratedTimesheetFlow